import axios from 'axios';
import storage from 'local-storage-fallback';

export default async function({ route, store, redirect }) {
  const localStorage = !('localStorage' in window)
    ? storage
    : window.localStorage;

  const burstGeo = JSON.parse(localStorage.getItem('burst-geo-2'));

  const blockListCountry = (process.env.FILTER_COUNTRY || '').split(',');
  const blockListIP = (process.env.FILTER_IP || '').split(',');
  const whiteListIP = (process.env.FILTER_IP_WHITE || '').split(',');
  let blackListed = null;
  if (!burstGeo) {
    blackListed = await axios
      .get(`https://api.ipgeolocation.io/ipgeo?apiKey=${process.env.IPGEO_IP}`)
      .then(function(response) {
        if (response && response.data) {
          localStorage.setItem(
            'burst-geo-2',
            JSON.stringify({
              data: response.data,
              country_code: response.data.country_code2,
              ip: response.data.ip
            })
          );

          if (whiteListIP.includes(response.data.ip)) {
            return false;
          }

          return (
            blockListCountry.includes(response.data.country_code2) ||
            blockListIP.includes(response.data.ip)
          );
        }
        // console.log(response.data);
        return false;
      })
      .catch(function(error) {
        console.log('IPGEO API Failed', error);
        return false;
      });

    if (blackListed) {
      return redirect('/unavailable/');
    }
  } else {
    if (whiteListIP.includes(burstGeo.ip)) {
      return false;
    }

    if (
      blockListCountry.includes(burstGeo.country_code) ||
      blockListIP.includes(burstGeo.ip)
    ) {
      return redirect('/unavailable/');
    }
  }

  return true;
}
